import { Route, Routes } from 'react-router-dom';
import WebRoutes from './Routes/WebRoutes/WebRoutes';
import ProviderRoutes from './Routes/ProviderRoutes/ProviderRoutes';
import BusinessRoutes from './Routes/BusinessRoutes/BusinessRoutes';
import EmployeeRoutes from './Routes/EmployeeRoutes/EmployeeRoutes';
import CustomerRoutes from './Routes/CustomerRoutes/CustomerRoutes';
import LeadGenerationRoutes from './Routes/LeadGenerationRoutes/LeadGenerationRoutes';
import ReferralUserSidebar from './Container/ReferralUser/ReferralUserSidebar';
import ReferRoutes from './Routes/ReferRoutes/ReferRoutes';


function App() {
  return (
    <div className="App">
         <Routes>
        <Route path="/*" element={<WebRoutes/>} />
        <Route path="/admin-user/*" element={<ProviderRoutes/>} />
        <Route path="/business/*" element={<BusinessRoutes/>} />
        <Route path="/employee/*" element={<EmployeeRoutes/>} />
        <Route path="/customer/*" element={<CustomerRoutes/>} />
        <Route path="/referral/*" element={<ReferRoutes/>} />
        <Route path="/lead/*" element={<LeadGenerationRoutes/>} />
        </Routes>
    </div>
  );
}

export default App;
